import { useHistory } from "react-router";

interface PushWithParamsOptions {
    state?: any
    /** Any extra params to add or modify */
    addParams?: Record<string, string>
}
/** Calls `history.push()` and appends current query params */
export const pushWithParams = (history: ReturnType<typeof useHistory>, path: string, options?: PushWithParamsOptions) => {
    let queryString = history.location.search;
    if (options?.addParams) {
        const params = new URLSearchParams(history.location.search);
        Object.entries(options.addParams).forEach(([key, val]) => {
            params.set(key, val);
        });
        queryString = `?${params.toString()}`
    }
    history.push(path + queryString, options?.state);
}